module.exports = __webpack_public_path__ + "static/media/empty_data_icon.ba3c769f.svg";